import * as authenticationActions from '../actions/authenticationContext.actions';
import { put, retry, takeLatest } from 'redux-saga/effects';
import * as projectService from '../services/project.service';
import * as companyService from '../services/companySettings.service';
import { CompanySettings, GetProjectsParams, UserProject } from 'types';
import { AxiosResponse } from 'axios';
import { PayloadAction } from '@reduxjs/toolkit';
import { generateProductUrls } from '../utils';
import { retryAxiosCall } from '../utils/retry.utils';

const {
	getProjects,
	getProjectsRejected,
	getProjectsResolved,
	getCompanies,
	getCompaniesResolved,
	getCompaniesRejected,
	getProjectBySourceId,
	getProjectBySourceIdResolved,
	getProjectBySourceIdRejected,
} = authenticationActions;

function* getCompaniesSaga() {
	try {
		const {
			data: { companySettings },
		}: AxiosResponse<{ companySettings: CompanySettings[] }> = yield retry(
			5,
			1500,
			companyService.getCompanies,
		);

		if (companySettings) {
			yield put(getCompaniesResolved(companySettings));
		} else {
			throw new Error('something uknonwn happened', companySettings);
		}
	} catch (e) {
		yield put(getCompaniesRejected(e as Error));
	}
}

function* getProjectsSaga(action: PayloadAction<GetProjectsParams>) {
	try {
		const {
			data: { projectsByUser },
		} = yield retryAxiosCall(projectService.getProjects, [
			action?.payload?.queryParams ?? null,
		]);

		if (projectsByUser?.results) {
			const cursor = projectsByUser?.pagination?.cursor ?? null;
			const list = generateProductUrls(projectsByUser?.results || []);
			yield put(getProjectsResolved({ list, cursor }));
		} else {
			throw new Error('something unknown happened', projectsByUser);
		}
	} catch (e) {
		yield put(getProjectsRejected(e as Error));
	}
}

function* getProjectBySourceIdSaga(action: PayloadAction<string>) {
	try {
		const {
			data: { projectsByUser },
		} = yield retryAxiosCall(projectService.getProjects, [
			{ sourceId: action.payload },
		]);

		if (projectsByUser?.results && projectsByUser.results.length > 0) {
			const project = projectsByUser?.results[0] as UserProject;
			yield put(getProjectBySourceIdResolved(project));
		} else {
			const e = new Error('Project not found');
			yield put(getProjectBySourceIdRejected(e));
		}
	} catch (e) {
		yield put(getProjectBySourceIdRejected(e as Error));
	}
}

export function* watchGetProjectBySourceIdSaga() {
	yield takeLatest(getProjectBySourceId, getProjectBySourceIdSaga);
}

export function* watchGetProjectsSaga() {
	yield takeLatest(getProjects, getProjectsSaga);
}

export function* watchGetCompaniesSaga() {
	yield takeLatest(getCompanies, getCompaniesSaga);
}

export default [
	watchGetProjectsSaga(),
	watchGetCompaniesSaga(),
	watchGetProjectBySourceIdSaga(),
];
